module.exports = __webpack_public_path__ + "img/laba.025f6f4c.png";